import { getConnectionCookie } from 'portal-sdk';

import { isProduction } from 'bones/utils/environment';
import { isOnPremise } from 'bones/utils/portal/environment';
import { redirectToPortalHome } from 'bones/utils/portal/redirectToPortal';

export const checkPortalCookies = () => {
  if (isOnPremise() || !isProduction()) {
    return;
  }

  const connection = getConnectionCookie();
  if (!connection) {
    console.warn('redirecting to Portal because no connection cookie found');
    redirectToPortalHome(window);
  }
};
